import {
  appsInventoryApiGetReceipt,
  getAppsInventoryApiGetReceiptQueryKey,
} from '@/lib/api/generated/endpoints'
import type { StockReceiptOut } from '@/lib/api/generated/types.ts/stockReceiptOut'
import { queryOptions } from '@tanstack/react-query'

/**
 * Read-only stock receipt detail.
 *
 * Backend contract:
 *  - `GET /api/stock-receipts/{receipt_id}` → `StockReceiptOut` with embedded
 *    `lines: StockReceiptLineOut[]`.
 *
 * Cached briefly — receipts in `draft` are mutable (header + lines), so we
 * keep `staleTime` low enough that any inline edit committed elsewhere
 * shows up on the next page mount, while still avoiding a refetch on every
 * focus.
 */
export const receiptDetailQuery = (stockReceiptId: number) =>
  queryOptions({
    queryKey: getAppsInventoryApiGetReceiptQueryKey(stockReceiptId),
    queryFn: async ({ signal }) =>
      (await appsInventoryApiGetReceipt(stockReceiptId, { signal })) as unknown as StockReceiptOut,
    staleTime: 15_000,
    enabled: Number.isFinite(stockReceiptId) && stockReceiptId > 0,
  })
